import { useContext } from 'react'
import { CreatorContext } from './CreatorProvider'

function useMe() {
  const contextValue = useContext(CreatorContext)
  return contextValue && contextValue.creator
}

export default useMe
